import { About, Contact, Hero, Services } from "./Widgets"

export const Home = () => {
    return <>
        <Hero />
        <About />
        <Services />
        <Contact />
    </>
}   